module.exports = __webpack_public_path__ + "static/media/fonts-5.ffc5031c.svg";